// ===== DEBUGGED Jcindex.js =====
import { useContext, useState, useEffect, useRef } from "react";
import VehiclePagecard2 from "../../Cards/VehiclePagecard2";
import Header from "../../Header/Header";
import StateMap from "../../Maps/Statewisemap";
import Jccard from "../../Cards/Jccard";
import { FilterContext } from "../../../context/Filter";
import Jctable from "../../Table/Jctable1";
import JCmonthTable from "../../Table/Jctable2";
import Jctable3 from "../../Table/Jctable3";
import Jcbargraph from "../../Graphs/BarGraph/Jcbargraph";
import Jcline from "../../Graphs/LineGraph/Jcline";
import Jcdetailed from "../../spareSales/JC/Jcdetailed";
import { TbFilterDown } from "react-icons/tb";
import JCFilter from "./Jcfilter";
import JCcardtable from "../../Cards/Jccardtable";
import {
  fetchdealerWiseTableData,
  fetchJcMonthWiseGraphData,
  fetchJcstategraphdata,
  fetchlobPplPlWiseCountData,
  fetchlobWiseBoxesData,
  fetchpplWiseGraphData,
  fetchserviceTypeWiseCountData,
  lobPplPlWiseCountData,
  fetchallJobCardDetails,
  fetchallJobCardDetailsopen,
  fetchallJobCardDetailsclosed,
  fetchjobCardInvoiceAmount,
  fetchJobCardDetailsAvgTat,
  getJcJobCardTatChart
} from "./Jckpi";
import NavButtons from "../../NevBar/NavButtons";
import JcDetailedJobCardTat from "../../Graph/Barchart/JcDetailedJobCardTat";
import WaterMark from "../../WaterMark";

const Jcindex = () => {
  const {
    isvOpen,
    arn: parArn,
    childArn,
    jcPayload,
    setJcPayload,
  } = useContext(FilterContext);

  // Add debug logging
  // console.log(
  //   "Jcindex render - parArn:",
  //   parArn,
  //   "childArn:",
  //   childArn,
  //   "jcPayload:",
  //   jcPayload
  // );

  const shouldEnableQuery = Boolean(parArn || childArn);
  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // Use ref to track if we're already fetching to prevent multiple calls
  const isFetching = useRef(false);

  const handleFilterChange = () => {
    // console.log("Filter toggle clicked, current state:", isFilterOpen);
    setIsFilterOpen((prev) => !prev);
  };
  const { open } = useContext(FilterContext);

  const [jcStateGraphData, setJcStateGraphData] = useState(null);
  const [jcMonthWiseGraphData, setJcMonthWiseGraphData] = useState(null);
  const [jcPplWiseBarGraph, setJcPplWiseGraphData] = useState(null);
  const [jcLobWiseBoxesData, setJcLobWiseBoxesData] = useState(null);
  const [jcDealerWiseTableData, setJcDealerWiseTableData] = useState(null);
  const [jcServiceTypeTableData, setJcServiceTypeTableData] = useState(null);
  const [jcLobPplPlWiseData, setJcLobPplPlWiseData] = useState(null);
  const [allJobCardDetailsData, setAllJobCardDetailsData] = useState(null);
  const [alljobCardInvoiceAmountnonac, setAlljobCardInvoiceAmountnonac] =
    useState(null);
  const [alljobCardInvoiceAmount, setAlljobCardInvoiceAmount] = useState(null);
  const [allJobCardDetailsDataopen, setAllJobCardDetailsDataopen] =
    useState(null);
  const [allJobCardDetailsDataopennonac, setAllJobCardDetailsDataopennonac] =
    useState(null);
  const [
    allJobCardDetailsDataclosednonac,
    setAllJobCardDetailsDataclosednonac,
  ] = useState(null);
  const [allJobCardDetailsDataclosed, setAllJobCardDetailsDataclosed] =
    useState(null);
  const [allJobCardDetailsDatanonac, setAllJobCardDetailsDatanonac] =
    useState(null);

  const [openAcAvgTat, setOpenAcAvgTat] = useState(null);
  const [openNonAcAvgTat, setOpenNonAcAvgTat] = useState(null);

  const [closedAcAvgTat, setClosedAcAvgTat] = useState(null);
  const [closedNonAcAvgTat, setClosedNonAcAvgTat] = useState(null);

  const [allAcAvgTat, setAllAcAvgTat] = useState(null);
  const [allNonAcAvgTat, setAllNonAcAvgTat] = useState(null);
  const [jobCardTatGraphData, setJobCardTatGraphData] = useState(null)

  const isValidData = (data) =>
    data !== null && typeof data === "object" && Object.keys(data).length > 0;

  const refetchAllVehicleData = async () => {
    if (!shouldEnableQuery || isFetching.current) {
      // console.log(
      //   "Skipping fetch - shouldEnableQuery:",
      //   shouldEnableQuery,
      //   "isFetching:",
      //   isFetching.current
      // );
      return;
    }

    // console.log("Starting data fetch...");
    isFetching.current = true;
    setLoading(true);

    try {
      const [
        JcStateGraphResp,
        jcMonthWiseGraphResp,
        jcPplWiseBarGraphResp,
        jcLobWiseBoxesResp,
        jcDealerWiseTableResp,
        jcServiceTypeWiseTableResp,
        jcLobPplPlWiseTableResp,
        openAc,
        openNonAc,
        closedAc,
        closedNonAc,
        allAc,
        allNonAc,
        InvoiceAmountnonac,
        InvoiceAmount,
        openAcAvgTatResp, // Corresponds to Open + Accidental fetch
        openNonAcAvgTatResp, // Corresponds to Open + Non-Accidental fetch
        closedAcAvgTatResp, // Corresponds to Closed + Accidental fetch
        closedNonAcAvgTatResp, // Corresponds to Closed + Non-Accidental fetch
        allAcAvgTatResp, // Corresponds to All + Accidental fetch
        allNonAcAvgTatResp,
        jobCardTatDataResp
      ] = await Promise.all([
        fetchJcstategraphdata(parArn, childArn, jcPayload),
        fetchJcMonthWiseGraphData(parArn, childArn, jcPayload),
        fetchpplWiseGraphData(parArn, childArn, jcPayload),
        fetchlobWiseBoxesData(parArn, childArn, jcPayload),
        fetchdealerWiseTableData(parArn, childArn, jcPayload),
        fetchserviceTypeWiseCountData(parArn, childArn, jcPayload),
        lobPplPlWiseCountData(parArn, childArn, jcPayload),
        fetchallJobCardDetailsopen(
          parArn,
          childArn,
          "Open",
          "Accidental",
          jcPayload
        ),
        fetchallJobCardDetailsopen(
          parArn,
          childArn,
          "Open",
          "Non-Accidental",
          jcPayload
        ),
        fetchallJobCardDetailsclosed(
          parArn,
          childArn,
          "Closed",
          "Accidental",
          jcPayload
        ),
        fetchallJobCardDetailsclosed(
          parArn,
          childArn,
          "Closed",
          "Non-Accidental",
          jcPayload
        ),
        fetchallJobCardDetails(
          parArn,
          childArn,
          "All",
          "Accidental",
          jcPayload
        ),
        fetchallJobCardDetails(
          parArn,
          childArn,
          "All",
          "Non-Accidental",
          jcPayload
        ),
        fetchjobCardInvoiceAmount(
          parArn,
          childArn,
          "Non-Accidental",
          jcPayload
        ),
        fetchjobCardInvoiceAmount(parArn, childArn, "Accidental", jcPayload),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "Open",
          "Accidental",
          jcPayload
        ),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "Open",
          "Non-Accidental",
          jcPayload
        ),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "Closed",
          "Accidental",
          jcPayload
        ),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "Closed",
          "Non-Accidental",
          jcPayload
        ),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "All",
          "Accidental",
          jcPayload
        ),
        fetchJobCardDetailsAvgTat(
          parArn,
          childArn,
          "All",
          "Non-Accidental",
          jcPayload
        ),
        getJcJobCardTatChart(parArn, childArn),
      ]);

      setJcStateGraphData(JcStateGraphResp || {});
      setJcMonthWiseGraphData(jcMonthWiseGraphResp || {});
      setJcPplWiseGraphData(jcPplWiseBarGraphResp || {});
      setJcLobWiseBoxesData(jcLobWiseBoxesResp || {});
      setJcDealerWiseTableData(jcDealerWiseTableResp || {});
      setJcServiceTypeTableData(jcServiceTypeWiseTableResp || {});
      setJcLobPplPlWiseData(jcLobPplPlWiseTableResp || {});
      setAllJobCardDetailsDataopen(openAc || "NA");
      setAllJobCardDetailsDataopennonac(openNonAc || "NA");
      setAllJobCardDetailsDataclosed(closedAc || "NA");
      setAllJobCardDetailsDataclosednonac(closedNonAc || "NA");
      setAllJobCardDetailsData(allAc || "NA");
      setAllJobCardDetailsDatanonac(allNonAc);
      setAlljobCardInvoiceAmountnonac(InvoiceAmountnonac || "NA");
      setAlljobCardInvoiceAmount(InvoiceAmount || "NA");
      setOpenAcAvgTat(openAcAvgTatResp || "NA");
      setOpenNonAcAvgTat(openNonAcAvgTatResp || "NA");

      setClosedAcAvgTat(closedAcAvgTatResp || "NA");
      setClosedNonAcAvgTat(closedNonAcAvgTatResp || "NA");

      setAllAcAvgTat(allAcAvgTatResp || "NA");
      setAllNonAcAvgTat(allNonAcAvgTatResp || "NA");
      setJobCardTatGraphData(jobCardTatDataResp || {});

      // console.log("Data fetch completed successfully");
    } catch (error) {
      console.error("Error fetching complaint data:", error);
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };
  // console.log("rr", allJobCardDetailsDataclosednonac);

  // ===== CRITICAL FIX: Add dependency comparison to prevent infinite loops =====
  const prevPayloadRef = useRef();
  const payloadChanged =
    JSON.stringify(prevPayloadRef.current) !== JSON.stringify(jcPayload);

  useEffect(() => {
    if (payloadChanged) {
      // console.log("Payload changed, refetching data");
      prevPayloadRef.current = jcPayload;
      refetchAllVehicleData();
    }
  }, [payloadChanged]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[80vh]">
        <div className="text-xl font-semibold">Loading JC Details data...</div>
      </div>
    );
  }
  // console.log(
  //   jobCardTatGraphData
  // );
  return (
    <div>
      <WaterMark />
      <Header heading={"Job Card Details"} />
      <div>
        {isFilterOpen && (
          <div className="w-full">
            <JCFilter />
          </div>
        )}
        <div
          className={`top-0  justify-center justify-items-center  left-0 z-10 block md:flex`}
        >
          <div className="block md:flex   ">
            <Jccard
              data={allJobCardDetailsData}
              data1={allJobCardDetailsDatanonac}
              data2={allJobCardDetailsDataopen}
              data3={allJobCardDetailsDataopennonac}
              data4={allJobCardDetailsDataclosed}
              data5={allJobCardDetailsDataclosednonac}
              data6={alljobCardInvoiceAmount}
              data7={alljobCardInvoiceAmountnonac}
              openAcAvgTat={openAcAvgTat}
              openNonAcAvgTat={openNonAcAvgTat}
              closedAcAvgTat={closedAcAvgTat}
              closedNonAcAvgTat={closedNonAcAvgTat}
              allAcAvgTat={allAcAvgTat}
              allNonAcAvgTat={allNonAcAvgTat}
            />
          </div>

          <div
            className="bg-[#087FC3] rounded-md p-2 w-10 h-12 mt-12 flex justify-center items-center cursor-pointer"
            onClick={handleFilterChange}
          >
            <TbFilterDown className={`text-white text-[70px] `} />
          </div>
        </div>

        <div className=" justify-items-center block md:grid gap-2 grid-cols-3 m-1">
          <VehiclePagecard2
            heading="State Wise Job cards"
            des={<StateMap data={jcStateGraphData} />}
          />
          <VehiclePagecard2
            heading="Month Wise Job Cards"
            des={<Jcline data={jcMonthWiseGraphData} />}
          />
          <VehiclePagecard2
            heading="PPL Wise Job Cards"
            des={
              <Jcbargraph data={jcPplWiseBarGraph} data2={jcLobWiseBoxesData} />
            }
          />
        </div>

        <div className="  justify-items-center md:grid grid-cols-3 gap-2 m-1 ">
          <VehiclePagecard2
            heading="State-Wise Distribution"
            des={<Jctable dealerWiseTableData={jcDealerWiseTableData} />}
          />
          <VehiclePagecard2
            heading="Month Wise Job Cards"
            des={
              <JCmonthTable serviceTypeWiseCountData={jcServiceTypeTableData} />
            }
          />

          <VehiclePagecard2
            heading="Month Wise Job Cards"
            des={<Jctable3 data={jcLobPplPlWiseData} />}
          />
        </div>

        <div className=" ml-3 md:ml-0 w-96 md:w-full max-w-[1200px]  border rounded-lg mx-2">
          <p className="p-1  bg-[#2374BF] text-white rounded-t-lg font-semibold">Job Card TAT</p>
          <JcDetailedJobCardTat data={jobCardTatGraphData} />
        </div>
        <div className=" m-1 ml-3 md:ml-0 ">
          <JCcardtable heading="Detailed Job Cards" des={<Jcdetailed />} />
        </div>
      </div>
      <NavButtons />
    </div>
  );
};

export default Jcindex;
